<template>
    <div class=" w-full mx-auto">
        <div v-if="totalCount != 0">
            <div class="overflow-x-auto generic-table-div" style="scrollbar-width: thin;">
                <table class="min-w-full divide-y divide-gray-200 mx-auto ">
                    <thead class="bg-gray-50 ">
                        <tr>
                            <!-- Empty header for remove col -->
                            <th v-if="isEditMode" scope="col" class="px-6 py-3 text-start"></th>
                            <template v-for="( header, key ) in columns " :key="key">
                                <th scope="col" class="px-6 py-3 text-start">
                                    <div class="flex items-center gap-x-2">
                                        <span
                                            class="text-xs font-semibold uppercase tracking-wide text-gray-800 text-nowrap">
                                            {{ header.name }}
                                        </span>
                                    </div>
                                </th>
                            </template>
                        </tr>
                    </thead>

                    <template v-for="( item, index ) in Array.isArray(data) ? data : [data] " :key="index">
                        <tbody class="divide-y divide-gray-200 ">
                            <tr class=" hover:bg-gray-50 bg-white" style="cursor:pointer;"
                                @click="$emit('rowClicked', item, index);">
                                <td v-if="isEditMode" class="size-px whitespace-nowrap">
                                    <span class="block px-6 py-1">
                                        <Button icon="pi pi-trash text-red-800" class="hover:bg-gray-200"
                                            @click="$emit('removeItem', item)" />
                                    </span>
                                </td>
                                <template v-for="( header ) in columns " :key="header.key">
                                    <td class="size-px whitespace-nowrap">
                                        <span class="block px-6 py-[4px]">
                                            <input v-if="typeof byString(item, header.key) == 'boolean'" type="checkbox"
                                                :disabled="!isEditMode" :checked="byString(item, header.key)" />
                                            <span v-else class="font-mono text-sm text-blue-600 ">
                                                {{ byString(item, header.key) == undefined || byString(item,
                                                    header.key)?.length == 0 ? '-' : byString(item, header.key)?.toString()
                                                }}</span>
                                        </span>
                                    </td>
                                </template>
                            </tr>
                        </tbody>
                    </template>
                </table>
            </div>
            <div v-if="totalCount" class="px-6 py-4 flex justify-between items-center border-t border-gray-200 ">
                <div>
                    <div>
                        <p class="text-sm text-gray-700">
                            Showing
                            {{ ' ' }}
                            <span class="font-medium">{{ offset + 1 }}</span>
                            {{ ' ' }}
                            to
                            {{ ' ' }}
                            <span class="font-medium">{{ offset + data.length }}</span>
                            {{ ' ' }}
                            of
                            {{ ' ' }}
                            <span class="font-medium">{{ totalCount }}</span>
                            {{ ' ' }}
                            results
                        </p>
                    </div>
                </div>
                <div>
                    <div class="inline-flex gap-x-2">
                        <button v-if="offset != 0" type="button" @click="$emit('prevPage')"
                            class="py-1 px-2  inline-flex items-center gap-x-2 text-m font-medium rounded-lg h-8 border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none">
                            <i class="pi pi-angle-left text-lg text-gray-800"></i>
                            Prev
                        </button>
                        <button v-if="totalCount > offset + limit" type="button" @click="$emit('nextPage')"
                            class="py-1 px-2  inline-flex items-center gap-x-2 text-m font-medium rounded-lg h-8 border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none">
                            Next
                            <i class="pi pi-angle-right text-lg text-gray-800"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="text-center p-5">
            <div class="flex w-full justify-center">
                <h1 class="text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl">
                    {{ message ? message.title : 'No results' }}
                </h1>
            </div>
            <p class="mt-1 text-base leading-7 text-gray-600">
                {{ message ? message.paragraph : 'Sorry, we cannot find any results matching the parameters' }}
            </p>
        </div>
    </div>
</template>

<script setup lang="ts">
import { defineProps, defineEmits } from 'vue';
import Button from 'primevue/button';
import 'primeicons/primeicons.css'

const emit = defineEmits(['nextPage', 'prevPage', 'rowClicked', 'captainChange', 'keeperChange', 'removeItem'])
defineProps(['data', 'columns', 'totalCount', 'active', 'routeName', 'hasTableRoute', 'offset', 'limit', 'isEditMode', 'message'])

/**
 * Function that takes a string index with dot notation and returns the value from object 
 * @param o Object to be indexed
 * @param s string represting index
 */
function byString(o: { [x: string]: any; }, s: string) {
    const properties = s.split(".");
    for (let i = 0; i < properties.length; i++) {
        if (!o) return null;
        o = o[properties[i]];
    }
    return o;
}

</script>
